module.exports = __webpack_public_path__ + "static/media/memphis-2.9b7f571b.png";